export var Type;
(function (Type) {
    Type["SECONDS"] = "SECONDS";
    Type["MINUTES"] = "MINUTES";
    Type["HOURS"] = "HOURS";
    Type["DAY"] = "DAY";
    Type["MONTH"] = "MONTH";
    Type["YEAR"] = "YEAR";
})(Type || (Type = {}));
